import gql from "graphql-tag";
import RelatedStoriesFieldsFragment from "./RelatedStoriesFieldsFragment";

const StoryFieldsFragment = gql`
  fragment StoryFields on Story {
    _id
    slug
    title
    introduction
    body
    highlights
    createdAt
    modifiedAt
    verticalCover
    viewerCanRead
    commentsCount
    author {
      ... on VendorUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        title
        avatar
      }
      ... on GovernmentUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        title
        avatar
      }
      ... on PendingUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        avatar
      }
    }

    coauthors {
      ... on VendorUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        title
        avatar
      }
      ... on GovernmentUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        title
        avatar
      }
      ... on PendingUser {
        _id
        firstName
        slug
        isSiteAdmin
        isLimitedSiteAdmin
        fullName
        jobTitle
        avatar
      }
    }

    vendorCoauthors {
      _id
      name
      logo
      slug
    }

    products {
      _id
      name
      slug
      isDisruptor
      logo
    }
    collaborators {
      ... on PendingUser {
        _id
        fullName
        firstName
        avatar
        slug
        jobTitle
        isSiteAdmin
        isLimitedSiteAdmin
      }
      ... on GovernmentUser {
        _id
        fullName
        firstName
        avatar
        slug
        jobTitle
        title
        isSiteAdmin
        isLimitedSiteAdmin
      }
      ... on VendorUser {
        _id
        fullName
        firstName
        avatar
        slug
        jobTitle
        title
        isSiteAdmin
        isLimitedSiteAdmin
      }
    }
    tags {
      _id
      name
      slug
    }
    awards {
      _id
      name
    }
    government {
      _id
      name
      logo
      slug
      city {
        _id
        country
      }
    }
    locations {
      _id
      name
      logo
      slug
      city {
        _id
        country
      }
    }
    viewerDidUpvote
    viewerDidBookmark
    medias {
      url
      type
      alt
    }
    resources {
      ... on LinkResource {
        title
        url
        addedAt
      }
      ... on DownloadResource {
        title
        url
        filename
        addedAt
      }
      ... on TextResource {
        title
        body
        addedAt
      }
    }
    newsworthy {
      url
      title
      description
      favicon
      siteName
    }
    relatedStories {
      ...RelatedStoriesFields
    }
  }

  ${RelatedStoriesFieldsFragment}
`;

export default StoryFieldsFragment;
